import React, { Component } from 'react';
import _ from 'lodash';
import AudioPlayer from 'react-responsive-audio-player';
import { decode } from 'he'

import { getFromDrupalAPI } from '../fetchJSON.js';

import '../../assets/css/audioplayer.css'

class LatestSermon extends Component {

  constructor(props) {
    super(props);
    var bgClass = props.background === "dark" ? 'special-row' : '';
    this.state = { backgroundClass: bgClass, sermon: null }
  }

  componentWillMount() {
    var that = this;
    getFromDrupalAPI('all_sermons_api?limit=1', function (data) {
      that.setState({ sermon: data })
    });
  }

  render() {
    var latestSermon = _.map(this.state.sermon, (sermon) => {
      return (
        <section key={_.uniqueId()}>
          <p className="lead"><strong>{decode(sermon.node_title)}</strong></p>
          <p><strong>{sermon.text ? decode(sermon.text) : ''}</strong><br />
          Sermon Series: {sermon.sermonseries ? decode(sermon.sermonseries) : ''}<br />
          Preacher: {sermon.preacher ? decode(sermon.preacher) : ''}</p>
          <p>{sermon.datePreached}</p>
          <p></p>
          <AudioPlayer playlist={[{ url: sermon.url, title: decode(sermon.node_title) }]} controls={['playpause', 'spacer', 'progress']} />
        </section>
      )
    });

    return (
      <section id="sermon" className={`padding100 ${this.state.backgroundClass}`}>
        <div className="container">

          <h1 className="text-center"><strong>Latest Sermon</strong></h1>
          <div className="divider">
            <i className="fa fa-star"></i>
          </div>

          {latestSermon}
          <br />
          <p className="text-right">
            A full list of our older sermons can be found <a href="/Sermons">here</a>
          </p>
        </div>
      </section>
    );
  }
}

export default LatestSermon;
